import TableHead, { TableHeadProps } from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Box from "@mui/material/Box";
import pick from "lodash/pick";
import { CSSProperties, memo } from "react";
import { LinearProgress } from "@mui/material";
import { useStyles } from "../DataTable.styles";
import { Column, EnumFilterTypes } from "../DataTable.type";
import { FilterCell } from "./FilterCell";
import { getColumnWidths } from "../utils";
import useJStyles from "$hooks/useJStyles";

type Props = {
  thead?: Column[];
  isLoading?: boolean;
  isVirtualized?: boolean;
} & TableHeadProps;

export const Thead = memo(
  ({ thead, isLoading, isVirtualized = false, ...tableHeadProps }: Props) => {
    const classes = useStyles();
    const { jclasses } = useJStyles();

    // SEE maybe will make the loading here, this will change anyway for the filters
    if (!thead?.length) {
      return null;
    }

    // Une seule colonne garde le testid par défaut ("jetest") des inputs
    // génériques, pour ne pas casser les tests e2e qui le ciblent déjà sur
    // les tableaux à une seule colonne texte filtrable. Les colonnes
    // suivantes reçoivent un testid dérivé de leur id pour éviter toute
    // ambiguïté quand plusieurs colonnes texte sont filtrables sur la même page.
    const firstTextFilterColumnId = thead.find(
      (column) =>
        column.filter?.type === EnumFilterTypes.INPUT ||
        column.filter?.type === EnumFilterTypes.INPUT_NUMBER
    )?.id;
    const columnWidths = getColumnWidths(thead);

    return (
      <TableHead className={classes.tableTitle} {...tableHeadProps}>
        <TableRow
          style={
            isVirtualized
              ? { display: "table-header-group", width: "100%" }
              : {}
          }
        >
          {thead?.map((column: Column, index: number) => {
            const styles = pick(column, ["style"]) as unknown as CSSProperties;
            const width = columnWidths[index];
            const { valueFilter: _valueFilter, ...filter } =
              column.filter || {};
            return (
              <TableCell
                key={column.id}
                align={column.align}
                className={classes.tableCell}
                style={{ ...styles, width }}
                padding="none"
              >
                <Box className={classes.tableCellIn}>
                  {column.label && !column.filter && (
                    <Box className={jclasses.jTopHead} style={{ minWidth: 0 }}>
                      {column.label}
                    </Box>
                  )}
                  {filter && (
                    <FilterCell
                      {...filter}
                      name={column.id}
                      {...(column.id !== firstTextFilterColumnId &&
                      (filter.type === EnumFilterTypes.INPUT ||
                        filter.type === EnumFilterTypes.INPUT_NUMBER)
                        ? { testid: `jetest-${column.id}` }
                        : {})}
                    />
                  )}
                </Box>
              </TableCell>
            );
          })}
        </TableRow>
        {isLoading && (
          <tr style={{ height: 4 }}>
            <td colSpan={1000}>
              <LinearProgress />
            </td>
          </tr>
        )}
      </TableHead>
    );
  }
);
